export default __webpack_public_path__ + "static/media/slack.702222f6.svg";